<!--
 * @Author: dengyao
 * @Date: 2021-05-25 16:30:33
 * @LastEditTime: 2021-08-31 17:29:06
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
  /* position: relative; */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/App.vue